"use client";

import { cn } from "@/lib/utils";

interface CollectionIconProps {
  icon?: string | null;
  color?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function CollectionIcon({
  icon,
  color,
  size = "md",
  className,
}: CollectionIconProps) {
  const sizeClasses = {
    sm: "w-4 h-4 text-sm",
    md: "w-6 h-6 text-base",
    lg: "w-10 h-10 text-2xl",
  };

  const defaultColor = "#3b82f6"; // Default blue
  const iconColor = color || defaultColor;

  // Helper to convert hex to rgba for gradients
  const hexToRgba = (hex: string, alpha: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return (
    <div
      className={cn(
        "rounded-xl flex items-center justify-center shrink-0 transition-all duration-300 group-hover:scale-110 shadow-sm",
        sizeClasses[size],
        className,
      )}
      style={{
        background: `linear-gradient(135deg, ${iconColor} 0%, ${hexToRgba(iconColor, 0.85)} 100%)`,
        boxShadow: `0 4px 12px -2px ${hexToRgba(iconColor, 0.25)}, 0 2px 4px -1px ${hexToRgba(iconColor, 0.1)}`,
      }}
    >
      <span className="opacity-95">{icon || "📁"}</span>
    </div>
  );
}
